import { createAction, props } from "@ngrx/store"; // Action is an interface of type string
import { Course } from "cli-types";

// ------ Load student teacher-classes ------

export const loadStudentCourses = createAction(
    "[Student Courses] Load Student Courses"
);
export const loadStudentCoursesFail = createAction(
    "[Student Courses] Load Student Courses Fail",
    props<{ payload: any }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const loadStudentCoursesSuccess = createAction(
    "[Student Courses] Load Student Courses Success",
    props<{ payload: Course[] }>()
);

// ------ Load teacher-classes ------
export const loadCourse = createAction(
    "[Student Courses] Load Course",
    props<{ payload: number }>()
);
export const loadCourseFail = createAction(
    "[Student Courses] Load Course Fail",
    props<{ payload: any }>()
); // if failure, we need constructor to send a message as the payload property back from the server
export const loadCourseSuccess = createAction(
    "[Student Courses] Load Course Success",
    props<{ payload: Course }>()
);

// ------ Set Selected Course ------
export const setSelectedCourse = createAction(
    "[Student Courses] Set Selected Course",
    props<{ payload: Course | null }>()
);

// ------ Update Selected Course  ------
export const updateSelectedCourseSuccess = createAction(
    "[Student Courses] Updated Selected Course Success",
    props<{ courseID: number | null }>()
);
export const updateSelectedCourseFail = createAction(
    "[Student Courses] Updated Selected Course Fail"
);

export const selectedCourseNoAction = createAction(
    "[Student Courses] Selected Course No Action"
);

// ------ Load Selected Course  ------
export const loadSelectedCourse = createAction(
    "[Courses] Load Selected Course",
    props<{ courseID: number }>()
);
export const loadSelectedCourseFail = createAction(
    "[Courses] Load Selected Course Fail"
);
export const loadSelectedCourseSuccess = createAction(
    "[Courses] Load Selected Course Success",
    props<{ course: Course }>()
);

// ----- Clear Store
export const clearCoursesStore = createAction("[Courses] Clear Courses Store");
